import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { systemInfoService } from '../../../services/SystemInfoService';
import { systemInfoQueryKeys } from '../systemInfoQueryKeys';

export function useAppVersionsQuery(options?: { includeLacService?: boolean }) {
  const { user } = useAuth();
  const includeLacService = options?.includeLacService ?? false;
  const isEnabled = Boolean(user);

  return useQuery({
    queryKey: [
      ...systemInfoQueryKeys.versions(),
      includeLacService ? 'with-lac' : 'backend-only',
    ],
    enabled: isEnabled,
    queryFn: async () => {
      const backendService = await systemInfoService.getBackendServiceVersion();

      if (!includeLacService) {
        return { backendService };
      }

      const lacService = await systemInfoService.getLacServiceVersion();

      return {
        backendService,
        lacService,
      };
    },
    staleTime: 5 * 60 * 1000,
  });
}
